exports = module.exports = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "application-data-source-editor div.checkbox {\n  margin-left: 20px;\n}\napplication-data-source-editor div.checkbox label {\n  font-weight: 600;\n}\napplication-data-source-editor p {\n  margin-left: 20px;\n}\n", ""]);

